export default function ArrowUpIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 21) / 20)}
        viewBox='0 0 20 21'
        fill='currentColor'
      >
        <path d='M10.0003 3.8335C10.4606 3.8335 10.8337 4.20659 10.8337 4.66683V16.3335C10.8337 16.7937 10.4606 17.1668 10.0003 17.1668C9.54009 17.1668 9.16699 16.7937 9.16699 16.3335V4.66683C9.16699 4.20659 9.54009 3.8335 10.0003 3.8335Z' />
        <path d='M9.41042 4.07757C9.73586 3.75214 10.2635 3.75214 10.5889 4.07757L16.4223 9.91091C16.7477 10.2363 16.7477 10.764 16.4223 11.0894C16.0968 11.4149 15.5692 11.4149 15.2438 11.0894L9.99967 5.84534L4.7556 11.0894C4.43016 11.4149 3.90252 11.4149 3.57709 11.0894C3.25165 10.764 3.25165 10.2363 3.57709 9.91091L9.41042 4.07757Z' />
      </svg>
    </span>
  );
}
